// extracted by mini-css-extract-plugin
module.exports = {"desktopPickers":"DesktopPickers_desktopPickers__8cb6S","userCatalog":"DesktopPickers_userCatalog__3leZC","hotelierCatalog":"DesktopPickers_hotelierCatalog__3iChd"};